
export const handleHttpError = (response: any) => {
    if(response.data !== undefined && response.data.responseText !== undefined && response.data.responseText !== '' ){
        console.clear();
        return response.data.responseText;
    }
    console.clear();
    return "Oops, something went wrong!";
}